export const asSingleMember = <MemberType extends object>(member: MemberType | MemberType[] | null | undefined) => {
  if (Array.isArray(member)) {
    return member.length === 1 ? member[0] : null
  }
  return member ?? null
}
